export default "__VITE_ASSET__DrV4qrf1__"